import { CLASSIFICATION_TYPE, SearchInstanceDto } from '@app/components';

export const formatClassifications = (
  classificationName: CLASSIFICATION_TYPE,
  classifications: SearchInstanceDto['classifications'] = []
) => {
  return classifications
    .filter(
      ({ classificationTypeName }) =>
        classificationTypeName === classificationName
    )
    .map(({ classificationNumber }) => classificationNumber);
};
